
$(document).ready(function() {
	if(document.querySelector('.page-404')) {
		const interval = 1000
		window.setTimeout(function() {
			const $elem = document.querySelector('.page-404')
			const headerHeight = document.querySelector('#header').offsetHeight
			$elem.style.marginTop = headerHeight + 'px'
		}, interval)
	}
})
